import { useTranslation } from "react-i18next";
import EmptyStateCard from "src/components/EmptyState/EmptyStateCard";
import { useNavigate } from "react-router";
import { MainContentLayout } from "src/components/Layout/MainContentLayout";

const AccessDeniedPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <MainContentLayout>
            <EmptyStateCard
                title={t("cms.access_denied.title")}
                description={t("cms.access_denied.message")}
                illustration="defaultIllustration"
                action={{
                    label: t("cms.access_denied.back_to_home"),
                    icon: "home",
                    onClick: () => navigate("/"),
                }}
            />
        </MainContentLayout>
    );
};

export default AccessDeniedPage;
